import { css } from 'goober';
import React from 'react';
import State from '../../state';
import colors from '../../styles/colors';
import font from '../../styles/font';
import { humanize } from '../../utils/common';
import { HeartBeat, HeartIcon, HeartShell } from '../Heart';
import IconAnimation from '../IconAnimation';
import IconBubbles from '../IconBubbles';
import ShareIcon from '../ShareIcon';
import WhatsappIcon from '../WhatsappIcon';
const Wrapper = css `
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  position: relative;
`;
const Container = css `
  display: flex;
`;
const Text = css `
  text-align: center;
  font-weight: ${font.fontWtMedium};
  font-size: ${font.fontTiny};
  line-height: 12px;
  color: #ffffff;
  margin-top: 4px;
`;
const MarginLeft = css `
  margin-left: 32px;
`;
const IconContainer = css `
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;
const HeartAnimateContainer = css `
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  justify-content: center;
`;
const LikeShare = (props) => {
    const { liked, likeCount, shareCount, onLike, onShare, onSendAnalytics, } = props;
    const handleClick = () => {
        onLike();
        onSendAnalytics({
            variant: "likeShare" /* LIKE_SHARE */,
            action: 'like clicked',
        });
    };
    const handleShare = () => {
        onShare();
        onSendAnalytics({
            variant: "likeShare" /* LIKE_SHARE */,
            action: `share clicked - ${State.hasWhatsAppInstalled
                ? "whatsapp_share" /* WHATSAPP */
                : "generic_share" /* SHARE */}`,
        });
    };
    return (React.createElement("div", { className: Wrapper },
        React.createElement("div", { className: Container },
            React.createElement("div", { className: IconContainer },
                React.createElement(IconAnimation, { icon: React.createElement(HeartShell, null,
                        React.createElement(HeartBeat, null,
                            React.createElement(HeartIcon, { liked: false, width: 28, height: 25 }))), animateicon: React.createElement("div", { className: HeartAnimateContainer },
                        React.createElement(HeartBeat, null,
                            React.createElement(HeartIcon, { liked: false, width: 28, height: 25 })),
                        React.createElement(IconBubbles, { color: colors.heartGradient })), onClick: handleClick }),
                React.createElement("div", { className: Text }, humanize(likeCount + (liked ? 1 : 0)))),
            React.createElement("div", { className: MarginLeft, onClick: handleShare },
                State.hasWhatsAppInstalled ? (React.createElement(WhatsappIcon, { width: 48, height: 48 })) : (React.createElement(ShareIcon, null)),
                React.createElement("div", { className: Text }, humanize(shareCount))))));
};
export default LikeShare;
//# sourceMappingURL=index.js.map